import React, { useCallback, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  getVideoDetails,
  updateVideoDetails,
} from "../../../api/functions/video.api";
import styles from "../../../styles/components/video.module.scss";
import styles1 from "../../../styles/components/commonAccordian.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import assest from "../../../json/assest";
import PerfectScrollbar from "react-perfect-scrollbar";
import ApiLoader from "../../Loaders/ApiLoader";
import CloseIcon from "@mui/icons-material/Close";
import {
  clipCopy,
  concatDownloadPath,
  concatHostAndVideoPath,
  openInNewTab,
  roleFinderTwo,
} from "../../../lib/functions/utils.lib";
import SubmissionInformation from "../components/SubmissionInformation";
import VideoDetailsPending from "../components/VideoDetailsPending";
import HlsPalyer from "../components/HlsPlayer";
import ShowVideoStatus from "../components/ShowVideoStatus";
import HandleVideo from "../components/HandleVideo";
import { getNote } from "../../../api/functions/note.api";
import PurchaseInformation from "../components/PurchaseInformation";
import BuyerHandleVideo from "../components/BuyerHandleVideo";
import VideoReleaseModal from "../../VideoReleaseModal/VideoReleaseModal";
import SuccessfullModal from "../components/modals/SuccessfullModal";
import CopyRightDisputeModal from "../../CopyRightDisputeModal/CopyRightDisputeModal";
import { getCookie } from "../../../lib/functions/storage.lib";
import MessageSubmitterDetails from "../components/MessageSubmitterDetails";
import CopyrightOwnershipsTwo from "../components/CopyrightOwnershipsTwo";
import TabPanel from "../../UtilitiesComponent/TabPanel";
import ExpandMoreIcon from "../../../public/assets/icons/ExpandMoreIcon";
import ArrowRightAngle from "../../../ui/Icons/ArrowRightAngle";
import useFetch from "../../../hooks/api/useFetch";
import { useNavigate } from "react-router";

const SuperAdminMessageVideoModal = ({ open, onClose, id, className }) => {
  const userCookie = getCookie("userdetails");
  let user = JSON.parse(userCookie ? userCookie : "{}");
  // console.warn("user///////////", user);

  const [bought, setBought] = useState(false);
  // console.warn("bought", bought);
  const {
    data,
    isLoading: isLoadingGet,
    refetch: refetchVideo,
    isRefetching: isRefetchingVideo,
  } = useQuery(
    ["video_details", id],
    async () => getVideoDetails(id, roleFinderTwo(user.role_id)),
    {
      enabled: id && open ? true : false,

      onSuccess: (data) => {
        // console.warn("data2", data);
        if (data.buyer) {
          setBought(true);
        } else {
          setBought(false);
        }
      },
    }
  );
  const {
    data: notes,
    isLoading: notesLoading,
    refetch: refetchNote,
  } = useQuery(["video_notes_details", id], async () => getNote(id), {
    enabled: id ? true : false,
  });

  // console.warn("video---data", data);
  // console.warn("isLoadingGet", isLoadingGet, isRefetchingVideo);
  // console.warn("note", notes);

  const [openApprove, setOpenApprove] = React.useState(false);
  const handleClickOpenApprove = () => {
    setOpenApprove(true);
  };
  const handleCloseApprove = () => {
    setOpenApprove(false);
  };

  /***************ProceedModal*****************/

  const [openProceed, setOpenProceed] = React.useState(false);
  const handleClickOpenProceed = () => {
    setOpenProceed(true);
  };
  const handleCloseProceed = () => {
    setOpenProceed(false);
  };

  /***************DenydModal*****************/

  const [openDeny, setOpenDeny] = React.useState(false);
  const handleClickOpenDeny = () => {
    setOpenDeny(true);
  };
  const handleCloseDeny = () => {
    setOpenDeny(false);
  };

  /***************VideoReleasedModal*****************/

  const [openVideoRelease, setOpenVideoRelease] = React.useState(false);
  const handleClickOpenVideoRelease = () => {
    setOpenVideoRelease(true);
  };
  const handleCloseVideoRelease = () => {
    setOpenVideoRelease(false);
  };

  /*****************************release video modal***************************/

  const [openCopyRightDispute, setOpenCopyRightDispute] = React.useState(false);
  const handleClickOpenCopyRightDispute = () => {
    setOpenCopyRightDispute(true);
  };
  const handleCloseCopyRightDispute = () => {
    setOpenCopyRightDispute(false);
  };

  const [succesUpdate, setSuccesUpdate] = useState();
  // console.warn("succesUpdate", succesUpdate);

  const { mutate, isLoading } = useMutation(updateVideoDetails, {
    onSuccess: async (data) => {
      // console.warn("data", data);
      setSuccesUpdate(data.status);
      refetchVideo();
      refetchNote();
    },
    onError: () => {
      console.warn("there was an error");
    },
  });

  const handleUpdate = (status) => {
    mutate({ id: data.id, status });
  };

  const closeSuccess = useCallback(() => {
    setSuccesUpdate(0);
  }, []);

  const [released, setReleased] = useState(false);

  useEffect(() => {
    if (data?.published == 2) {
      setReleased(true);
    }
  }, [data]);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [contentBuyerDropdown, setContentBuyerDropdown] = React.useState(false);
  const [qcAgentDropdown, setQcAgentDropdown] = React.useState(false);
  const [openThisYear2, setOpenThisYear2] = React.useState(false);
  const [openThisYear3, setOpenThisYear3] = React.useState(false);

  const handleToggleContentBuyerDropdown = () => {
    setContentBuyerDropdown(!contentBuyerDropdown);
  };

  const handleToggleQcAgentDropdown = () => {
    setQcAgentDropdown(!qcAgentDropdown);
  };

  const handleToggleThisYear2 = () => {
    setOpenThisYear2(!openThisYear2);
  };

  const handleToggleThisYear3 = () => {
    setOpenThisYear3(!openThisYear3);
  };

  const { data: contentBuyersList, isLoading: isLoadingContentBuyersList } =
    useFetch(["users-content-buyer"], "admin/users/9");
  const { data: qcAgentList, isLoading: isLoadingQcAgentList } = useFetch(
    ["users-quality-agent"],
    "admin/users/6"
  );
  const { data: managerList, isLoading: isLoadingmanagerList } = useFetch(
    ["users-manager"],
    "admin/users/7"
  );

  const navigate = useNavigate();
  const viewInquiry = (inquiryId) => {
    if (!inquiryId) return;
    navigate(`/message-details/${inquiryId}`);
  };

  console.warn(data);

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="messageVideoModal"
      >
        <Box className={styles.VideoPageScroll}>
          <ApiLoader
            // loading={notesLoading || isLoadingGet || isRefetchingVideo}
            loading={notesLoading || isLoadingGet}
          />

          <SuccessfullModal
            succesUpdate={succesUpdate}
            onClose={closeSuccess}
          />
          {/* released video portion */}
          <Dialog
            open={released}
            onClose={() => setReleased(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="CopyRightDisputeModal"
          >
            <CopyRightDisputeModal data={data} />
          </Dialog>

          {data && (
            <>
              <VideoReleaseModal
                openVideoRelease={openVideoRelease}
                handleCloseVideoRelease={handleCloseVideoRelease}
                data={data}
              />
              <Box className={styles.videoWrapper}>
                <Box className={styles.videoWrapperLeft}>
                  <Box className={styles.videoLeftScroll}>
                    <PerfectScrollbar>
                      <Box className="VideocommonBox">
                        <Box className={styles.videoSection}>
                          <Box className={styles.videoBox}>
                            <HlsPalyer
                              source={concatHostAndVideoPath(
                                data.converted_url
                              )}
                            />
                          </Box>

                          <Box className={styles.videoInput}>
                            <input
                              type="text"
                              disabled
                              placeholder={concatDownloadPath(data.video)}
                            />
                            <Button
                              onClick={() =>
                                clipCopy(concatDownloadPath(data.video))
                              }
                            >
                              <img
                                src={assest.copyIcon}
                                width={13}
                                height={16}
                                alt=""
                              />
                            </Button>
                          </Box>

                          {bought ? (
                            <>
                              <BuyerHandleVideo
                                data={data}
                                handleUpdate={handleUpdate}
                              />
                            </>
                          ) : (
                            <HandleVideo
                              data={data}
                              handleUpdate={handleUpdate}
                            />
                          )}

                          <Box
                            className={`${styles.selectWrapper} ${styles.selectWrapperMessage}`}
                          >
                            <Box className={styles.tble_hdng}>
                              <Button
                                onClick={handleToggleContentBuyerDropdown}
                                className={`${
                                  contentBuyerDropdown
                                    ? styles.active_drop
                                    : null
                                }`}
                              >
                                {contentBuyerDropdown ? (
                                  <img
                                    src={assest.messageContentIcon}
                                    width={14}
                                    height={14}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    src={assest.messageContentIcon}
                                    width={14}
                                    height={14}
                                    alt=""
                                  />
                                )}
                                Message Content Buyer{" "}
                              </Button>

                              {contentBuyerDropdown ? (
                                <Box className={styles.year_drop}>
                                  <ul>
                                    <li>
                                      <Box className={styles.yearClose}>
                                        Select a Content Buyer to message
                                        <CloseIcon />
                                      </Box>
                                    </li>
                                    {isLoadingContentBuyersList
                                      ? "Loading..."
                                      : contentBuyersList?.data?.data?.map(
                                          (item, index) => (
                                            <li key={index}>
                                              {item?.name ? item?.name : ""}{" "}
                                              {item?.last_name
                                                ? item?.last_name
                                                : ""}
                                            </li>
                                          )
                                        )}
                                  </ul>
                                </Box>
                              ) : null}
                            </Box>

                            <Box className={styles.tble_hdng}>
                              <Button
                                onClick={handleToggleQcAgentDropdown}
                                className={`${
                                  qcAgentDropdown ? styles.active_drop : null
                                }`}
                              >
                                {qcAgentDropdown ? (
                                  <img
                                    src={assest.messageContentIcon}
                                    width={14}
                                    height={14}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    src={assest.messageContentIcon}
                                    width={14}
                                    height={14}
                                    alt=""
                                  />
                                )}
                                Message QC Agent{" "}
                              </Button>

                              {qcAgentDropdown ? (
                                <Box className={styles.year_drop}>
                                  <ul>
                                    <li>
                                      <Box className={styles.yearClose}>
                                        Select a QC Agent to message
                                        <CloseIcon />
                                      </Box>
                                    </li>
                                    {isLoadingQcAgentList
                                      ? "Loading..."
                                      : qcAgentList?.data?.data?.map(
                                          (item, index) => (
                                            <li key={index}>
                                              {item?.name ? item?.name : ""}{" "}
                                              {item?.last_name
                                                ? item?.last_name
                                                : ""}
                                            </li>
                                          )
                                        )}
                                  </ul>
                                </Box>
                              ) : null}
                            </Box>

                            <Box className={styles.tble_hdng}>
                              <Button
                                onClick={handleToggleThisYear2}
                                className={`${
                                  openThisYear2 ? styles.active_drop : null
                                }`}
                              >
                                {openThisYear2 ? (
                                  <img
                                    src={assest.messageContentIcon}
                                    width={14}
                                    height={14}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    src={assest.messageContentIcon}
                                    width={14}
                                    height={14}
                                    alt=""
                                  />
                                )}
                                Message Manager{" "}
                              </Button>

                              {openThisYear2 ? (
                                <Box className={styles.year_drop}>
                                  <ul>
                                    <li>
                                      <Box className={styles.yearClose}>
                                        Select a Manager to message
                                        <CloseIcon />
                                      </Box>
                                    </li>
                                    {isLoadingmanagerList
                                      ? "Loading..."
                                      : managerList?.data?.data?.map(
                                          (item, index) => (
                                            <li key={index}>
                                              {item?.name ? item?.name : ""}{" "}
                                              {item?.last_name
                                                ? item?.last_name
                                                : ""}
                                            </li>
                                          )
                                        )}
                                  </ul>
                                </Box>
                              ) : null}
                            </Box>
                          </Box>

                          <Box className={styles.downloadButton}>
                            <Button
                              onClick={() =>
                                openInNewTab(concatDownloadPath(data.video))
                              }
                            >
                              <img
                                src={assest.doenloadVideoicon}
                                width={13}
                                height={14}
                                alt=""
                              />{" "}
                              Download Video
                            </Button>
                            <Button>
                              <img
                                src={assest.downloadAssignment}
                                width={14}
                                height={14}
                                alt=""
                              />{" "}
                              Download Redacted Agreement
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                      {!bought ? (
                        <VideoDetailsPending
                          refetchVideo={refetchVideo}
                          data={data}
                        />
                      ) : (
                        <>
                          <Box className={styles.purchedBox}>
                            <p>
                              Asset Was Purchased on behalf of ViralSnare by:{" "}
                              <span> {data.buyer?.name} </span>{" "}
                              <span className={styles.purchedBoxSpan}>
                                (Content Buyer)
                              </span>
                            </p>
                          </Box>
                        </>
                      )}
                    </PerfectScrollbar>
                  </Box>
                </Box>

                <Box className={styles.videoWraperRight}>
                  <Box className={styles.videoRightScroll}>
                    <PerfectScrollbar>
                      <Box className={styles.videoOwner}>
                        <ShowVideoStatus
                          notes={notes}
                          data={data}
                          handleUpdate={handleUpdate}
                          refetchNote={refetchNote}
                          onClose={onClose}
                        />
                        <MessageSubmitterDetails hideCross data={data} />
                        {bought ? (
                          <VideoDetailsPending
                            refetchVideo={refetchVideo}
                            data={data}
                          />
                        ) : (
                          <CopyrightOwnershipsTwo data={data} />
                        )}
                      </Box>
                      {bought ? (
                        <>
                          <PurchaseInformation data={data} />
                        </>
                      ) : (
                        <>
                          <SubmissionInformation data={data} />
                        </>
                      )}

                      <Box className={styles1.commonAccordianWrapper}>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography>Team Messages</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Stack
                              className={styles1.messageTeamBody}
                              direction={"row"}
                              justifyContent={"space-between"}
                            >
                              {data?.manager_inquries?.map((item, index) => (
                                <Box
                                  className={`${styles1.teamBodyCard} ${styles1.teamBodyCardActive}`}
                                  key={index}
                                >
                                  <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    alignItems={"flex-start"}
                                  >
                                    <Typography variant="h4">
                                      Manager
                                    </Typography>
                                    <Button
                                      endIcon={<ArrowRightAngle />}
                                      onClick={() => viewInquiry(item?.id)}
                                    >
                                      View Now
                                    </Button>
                                  </Stack>
                                  <Button className={styles1.statusBtn}>
                                    {item?.status
                                      ? "Closed"
                                      : item?.admin_joined
                                      ? "Awaiting Manager's reply"
                                      : "Awaiting your reply"}
                                  </Button>
                                </Box>
                              ))}
                              {data?.manager_inquries?.map((item, index) => (
                                <Box
                                  className={`${styles1.teamBodyCard} ${styles1.teamBodyCardActive}`}
                                  key={index}
                                >
                                  <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    alignItems={"flex-start"}
                                  >
                                    <Typography variant="h4">
                                      Manager
                                    </Typography>
                                    <Button
                                      endIcon={<ArrowRightAngle />}
                                      onClick={() => viewInquiry(item?.id)}
                                    >
                                      View Now
                                    </Button>
                                  </Stack>
                                  <Button className={styles1.statusBtn}>
                                    {item?.status
                                      ? "Closed"
                                      : item?.admin_joined
                                      ? "Awaiting Manager's reply"
                                      : "Awaiting your reply"}
                                  </Button>
                                </Box>
                              ))}
                              {data?.partner_inquries?.map((item, index) => (
                                <Box
                                  className={`${styles1.teamBodyCard} ${styles1.teamBodyCardActive}`}
                                  key={index}
                                >
                                  <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    alignItems={"flex-start"}
                                  >
                                    <Typography variant="h4">
                                      Partner
                                    </Typography>
                                    <Button
                                      endIcon={<ArrowRightAngle />}
                                      onClick={() => viewInquiry(item?.id)}
                                    >
                                      View Now
                                    </Button>
                                  </Stack>
                                  <Button className={styles1.statusBtn}>
                                    {item?.status
                                      ? "Closed"
                                      : item?.admin_joined
                                      ? "Awaiting Partner's reply"
                                      : "Awaiting your reply"}
                                  </Button>
                                </Box>
                              ))}
                              {data?.quality_team_inquries?.map(
                                (item, index) => (
                                  <Box
                                    className={`${styles1.teamBodyCard} ${styles1.teamBodyCardActive}`}
                                    key={index}
                                  >
                                    <Stack
                                      direction={"row"}
                                      justifyContent={"space-between"}
                                      alignItems={"flex-start"}
                                    >
                                      <Typography variant="h4">
                                        QC Agent
                                      </Typography>
                                      <Button
                                        endIcon={<ArrowRightAngle />}
                                        onClick={() => viewInquiry(item?.id)}
                                      >
                                        View Now
                                      </Button>
                                    </Stack>
                                    <Button className={styles1.statusBtn}>
                                      {item?.status
                                        ? "Closed"
                                        : item?.admin_joined
                                        ? "Awaiting QC Agent's reply"
                                        : "Awaiting your reply"}
                                    </Button>
                                  </Box>
                                )
                              )}
                            </Stack>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    </PerfectScrollbar>
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Dialog>
    </>
  );
};

export default SuperAdminMessageVideoModal;
